import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './MFHoldings.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useParams } from "react-router-dom";
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function MFHoldings() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [co_code, setco_code] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [loadingshow, setloadingshow] = useState(false);
    const [nameCom, setNameCom] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const [data, setData] = useState([]);
    const { getCompName } = useParams();
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true)
        if (co_code != '') {
            const getUrl = BaseURL + "MFHoldings";
            fetch(`${getUrl}/${co_code}/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });

        }

    }, [co_code]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>MF Holdings</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>MF Holdings</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="MF Holdings" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            <div className="table-class">
                                {currentTableData && currentTableData.map(
                                    ({ sch_Name, MktValue, Perc_Hold }) => (
                                        <>
                                            <div className="mfhold-equity">
                                                <div className="mfhold-equity-inner">
                                                    <div className="mfhold-equity-beta">
                                                        {/* <div className="nameGroup"></div> */}
                                                        <div className="mf-gutter">
                                                            <div className="text-left"><b>{sch_Name}</b> </div><br></br>
                                                            {/* <td className="text-right"> {(close_price != null) ? close_price.toFixed(2) : 0}</td> */}
                                                            <div className="text-left"> Amt Invt(&#8377;Cr) :</div> <div className="text-right-fold">{(MktValue != null) ? MktValue.toFixed(2) : 0}</div>
                                                            <div className="text-left"> %AUM Invt In Stock :</div>   <div className="text-right-fold">{(Perc_Hold != null) ? Perc_Hold.toFixed(2) : 0}</div></div>

                                                    </div>
                                                </div>
                                            </div>


                                        </>



                                    ))}
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }

                            </div>


                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}



                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MFHoldings;